import { setLayersVisible } from "../../services/reducers/map";
import { useAppDispatch } from "../../hooks/useAppDispatch";

export type DebouncedFunction = (
  id: number,
  checked: boolean,
  type: "radio" | "checkbox/infrastructure",
  prevRadio?: number[],
) => void;

export function useDebounceLayers(selectedLayersId: number[]) {
  let indexes: number[] = selectedLayersId;
  let timer: NodeJS.Timeout;

  const dispatch = useAppDispatch();

  return function (
    id: number,
    checked: boolean,
    type: "radio" | "checkbox/infrastructure",
    prevRadio?: number[],
  ) {
    clearTimeout(timer);
    if (checked && type === "checkbox/infrastructure") {
      indexes = [...indexes, id];
    } else if (!checked && type === "checkbox/infrastructure") {
      indexes = [...indexes.filter((item) => item !== id)];
    } else {
      indexes = [...indexes.filter((item) => !prevRadio?.includes(item)), id];
    }

    timer = setTimeout(() => {
      dispatch(setLayersVisible(indexes));
    }, 1000);
  };
}
